import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ProfileService } from 'src/app/api/profile.service';
import { MobileWebViewService } from 'src/app/services/mobile-web-view.service';

@Component({
    selector: 'become-avip-page',
    templateUrl: './become-avip-page.component.html',
    styleUrls: ['./become-avip-page.component.scss'],
    standalone: false
})
export class BecomeAvipPageComponent implements OnInit {
  @ViewChild('joinVIP') joinVIP: ElementRef;

  vip = false;

  isMobileWebView$ = this.mobileWebViewService.isMobileWebView$;

  constructor(
    private router: Router,
    private mobileWebViewService: MobileWebViewService,
    private profileService: ProfileService,
  ) {}

  ngOnInit() {
    this.getProfile();
  }

  joinVip(anchor = false) {
    if (anchor) {
      return this.joinVIP.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    this.router.navigate(['/support/otc']);
  }

  getProfile() {
    this.profileService.getGeneral().subscribe(response => {
      this.vip = response?.vip;
    });
  }
}
